import { render, staticRenderFns } from "./PlayerClubGifts.vue?vue&type=template&id=3e704b1a&"
import script from "./PlayerClubGifts.vue?vue&type=script&lang=js&"
export * from "./PlayerClubGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports